let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("k2SV0")).then(() => parcelRequire('6BBXS'));